import axios from "axios";
import Vue from 'vue';
import dumper from 'vue-dumper';

window.dumper = dumper;

const baseURL = process.env.VUE_APP_BACKEND_URL;

window.onerror = function (msg, url, lineNo, columnNo, error) {
  axios.post(baseURL + '/rpc/log', {
    message: msg,
    url: url,
    line: lineNo,
    column: columnNo,
    errorObj: JSON.stringify(error)
  }).catch(() => {});
  return false;
};

window.onunhandledrejection = function (event) {
  axios.post(baseURL + '/rpc/log', event.reason).catch(() => {});
};

Vue.config.errorHandler = (err, vm, info) => {
  let dump;
  try {
    dump = JSON.parse(JSON.stringify(vm, function (key, value) {
      if (value && value.$options) {
        return dumper.getInstanceState(value);
      }
      return value;
    }));
    var _navigator = {};
    for (var i in navigator) _navigator[i] = navigator[i];
    console.error(err);
  } catch(e) {}
  axios.post(baseURL + '/rpc/log', {
    err: {
      message: err.message,
      stack: err.stack
    },
    navigator: JSON.stringify(_navigator), // serialize(navigator),
    vm: dump,
    info
  }).catch(() => {});
};


function serialize (object) {
  var type = typeof object;
  if (object === null) {
      return '"nullValue"';
  }
  if (type == 'string' || type === 'number' || type === 'boolean') {
      return '"' + object + '"';
  }
  else if (type === 'function') {
      return '"functionValue"';
  }
  else if (type === 'object') {
      var output = '{';
      for (var item in object) {
        try {
            if (item !== 'enabledPlugin') {
                output += '"' + item + '":' + serialize(object[item]) + ',';
            }
        }
        catch (e) {
        }
      }
      return output.replace(/\,$/, '') + '}';
  }
  else if (type === 'undefined') {
      return '"undefinedError"';
  }
  else {
      return '"unknownTypeError"';
  }
};
